export const CONF_FORMS: any[] = [
    {
        "columns" : [ {
            "name" : "configItemId",
            "title" : "Config Item"
        }, {
            "name" : "configItemName",
            "title" : "Name"
        }, {
            "name" : "configItemTypeId",
            "title" : "Type"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "submitButton",
            "title" : ""
        } ],
        "formName" : "EditProductConfigItems",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ConfigForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "width" : "",
            "name" : "configItemId",
            "alternate" : "",
            "event":"edit",
            "description" : "",
            "parameterList" : [ {
            "name" : "configItemId"
            } ],
            "id" : "EditProductConfigItems_configItemId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "EditProductConfigItem",
            "type" : "HYPERLINK",
            "formData":{
                "formName":"EditProductConfigItem",
                "formLocation":"component://kwikstore/widget/ConfigForms.xml"
            }
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "configItemName",
            "description" : "",
            "id" : "EditProductConfigItems_configItemName",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductConfigItems",
            "options" : [ {
            "description" : "",
            "key" : "SINGLE"
            }, {
            "description" : "",
            "key" : "MULTIPLE"
            } ],
            "disabled" : "false",
            "id" : "EditProductConfigItems_configItemTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "configItemTypeId",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "EditProductConfigItems_description",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditProductConfigItems",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditProductConfigItems_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateProductConfigItem"
    },
    {
        "formName" : "EditProductConfigItem",
        "titleDescriptionField":"configItemName",
        "idFieldName":"configItemId",
        "altTarget" : [ {
            "useWhen" : "configItem==null",
            "targetExdr" : {
            "chars" : "createProductConfigItem",
            "hint" : 20,
            "empty" : false,
            "original" : "createProductConfigItem"
            }
        } ],
        "targets":{
            "createTarget":"createProductConfigItem",
            "updateTarget":"updateProductConfigItem",
        },
        "formLocation" : "component://kwikstore/widget/ConfigForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "configItemId",
            "action" : "",
            "id" : "EditProductConfigItem_configItemId",
            "type" : "DISPLAY",
            "event" : "",
            "value" : "",
            "title" : "Config Item ID",
          },{
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Config Item Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductConfigItem",
            "options" : [ {
            "description" : "Single Choice",
            "key" : "SINGLE"
            }, {
            "description" : "Multi Choice",
            "key" : "MULTIPLE"
            } ],
            "disabled" : "false",
            "id" : "EditProductConfigItem_configItemTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "configItemTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Config Item Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "configItemName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductConfigItem_configItemName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductConfigItem_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditProductConfigItem",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditProductConfigItem_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateProductConfigItem"
    },
    {
        "formName" : "CreateConfigOption",
        "targets":{
            "createTarget":"createProductConfigOption",
            "updateTarget":"updateProductConfigOption"
        },
        "altTarget" : [ {
            "useWhen" : "configOption!=null",
            "targetExdr" : {
            "chars" : "updateProductConfigOption",
            "hint" : 20,
            "empty" : false,
            "original" : "updateProductConfigOption"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/ConfigForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "configItemId",
            "action" : "",
            "id" : "CreateConfigOption_configItemId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-16%2012:46:47.382",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "CreateConfigOption",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "CreateConfigOption_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-16%2012:46:47.383",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "CreateConfigOption",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "CreateConfigOption_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Config Option Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "configOptionName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "CreateConfigOption_configOptionName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "CreateConfigOption_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "CreateConfigOption_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "CreateConfigOption",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "CreateConfigOption_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductConfigOption"
    },
    {
        "columns" : [ {
            "name" : "configItemId",
            "title" : "Config Option"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "sequenceNum",
            "title" : "Sequence Num"
        }, {
            "name" : "deleteLink",
            "title" : "Remove"
        }, {
            "name" : "submitButton",
            "title" : "Update"
        } ],
        "formName" : "ProductConfigOptionList",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ConfigForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "configOptionId",
            "action" : "",
            "id" : "ProductConfigOptionList_configOptionId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "configOptionName",
            "action" : "",
            "id" : "ProductConfigOptionList_configOptionName",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Config Option",
            "type" : "HYPERLINK",
            "target" : "EditProductConfigOptions",
            "name" : "configItemId",
            "width" : "",
            "parameterList" : [ {
            "name" : "configItemId"
            }, {
            "name" : "configOptionId"
            } ],
            "style" : "",
            "id" : "ProductConfigOptionList_configItemId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formName":"EditProductConfigOptions",
                "formLocation":"component://kwikstore/widget/ConfigForms.xml"
            },
            "event":"edit",
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ProductConfigOptionList_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ProductConfigOptionList_thruDate",
            "title" : "",
            "type" : "DATE_TIME",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "ProductConfigOptionList_description",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "sequenceNum",
            "description" : "",
            "style" : "",
            "id" : "ProductConfigOptionList_sequenceNum",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Remove",
            "title" : "Remove",
            "type" : "HYPERLINK",
            "target" : "deleteProductConfigOption",
            "name" : "deleteLink",
            "width" : "",
            "parameterList" : [ {
            "name" : "configItemId"
            }, {
            "name" : "configOptionId"
            } ],
            "style" : "",
            "id" : "ProductConfigOptionList_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "event":"delete",
            "formData":{
                "formName":"deleteProductConfigOption",
                "formLocation":"component://kwikstore/widget/ConfigForms.xml"
            }
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ProductConfigOptionList",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "ProductConfigOptionList_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateProductConfigOption"
    },
    {
        "columns" : [ {
            "name" : "productId",
            "title" : "Product ID"
        }, {
            "name" : "quantity",
            "title" : "Quantity"
        }, {
            "name" : "sequenceNum",
            "title" : "Sequence Num"
        }, {
            "name" : "remove",
            "title" : "remove"
        } ],
        "formName" : "ProductConfigList",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ConfigForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "configItemId",
            "action" : "",
            "id" : "ProductConfigList_configItemId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "configOptionId",
            "action" : "",
            "id" : "ProductConfigList_configOptionId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : " - ",
            "title" : "Product ID",
            "type" : "HYPERLINK",
            "target" : "EditProduct",
            "name" : "productId",
            "width" : "",
            "parameterList" : [ {
            "fromField" : {
                "isEmpty" : false,
                "original" : "product.productId",
                "bracketedOriginal" : "${product.productId}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "product.productId"
            },
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ProductConfigList_productId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantity",
            "description" : "",
            "style" : "",
            "id" : "ProductConfigList_quantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "sequenceNum",
            "description" : "",
            "style" : "",
            "id" : "ProductConfigList_sequenceNum",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Remove",
            "title" : "remove",
            "type" : "HYPERLINK",
            "target" : "deleteProductConfigProduct",
            "name" : "remove",
            "width" : "",
            "parameterList" : [ {
            "name" : "configItemId"
            }, {
            "name" : "configOptionId"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "product.productId",
                "bracketedOriginal" : "${product.productId}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "product.productId"
            },
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ProductConfigList_remove",
            "imageTitle" : "",
            "parameterMap" : {
            "configItemId" : ""
            },
            "height" : ""
        } ],
        "target" : ""
    },
    {
        "columns" : [ {
            "name" : "productContentId",
            "title" : "Content"
        }, {
            "name" : "confItemContentTypeId",
            "title" : "Type"
        }, {
            "name" : "fromDate",
            "title" : "From Date  Time"
        }, {
            "name" : "thruDate",
            "title" : "Through Date  Time"
        }, {
            "name" : "deleteLink",
            "title" : " "
        }, {
            "name" : "contentId",
            "title" : "Content"
        } ],
        "formName" : "EditProductConfigItemContent",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ConfigForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "configItemId",
            "action" : "",
            "id" : "EditProductConfigItemContent_configItemId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Content",
            "type" : "HYPERLINK",
            "target" : "EditProductConfigItemContentContent",
            "name" : "productContentId",
            "width" : "",
            "parameterList" : [ {
            "name" : "configItemId"
            }, {
            "name" : "contentId"
            }, {
            "name" : "fromDate"
            } ],
            "style" : "",
            "id" : "EditProductConfigItemContent_productContentId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formName":"EditProductConfigItemContent",
                "formLocation" : "component://kwikstore/widget/ConfigForms.xml",
            },
            "event":"edit"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "confItemContentTypeId",
            "description" : "",
            "style" : "",
            "id" : "EditProductConfigItemContent_confItemContentTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "EditProductConfigItemContent_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date  Time",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-17%2010:43:52.37",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditProductConfigItemContent",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditProductConfigItemContent_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Delete",
            "parameterList" : [ {
            "name" : "configItemId"
            }, {
            "name" : "contentId"
            }, {
            "name" : "confItemContentTypeId"
            }, {
            "name" : "fromDate"
            } ],
            "id" : "EditProductConfigItemContent_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "removeContentFromProductConfigItem"
        }, {
            "hyperlink" : {
            "linkStyle" : "",
            "description" : "",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_13050dbd_b915_4ffa_b02c_cd35cfb96591",
            "target" : "EditContent",
            "targetWindow" : "",
            "remoteFormData":{
                "formData":{
                    "formName":"EditContent",
                    "formLocation":"component://kwikstore/widget/ContentForms.xml",
                }
            }
            },
            "event":"edit",
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contentId",
            "description" : "",
            "style" : "",
            "id" : "EditProductConfigItemContent_contentId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "contentId", "confItemContentTypeId", "fromDate", "thruDate", "submitButton" ]
        } ],
        "formName" : "AddProductConfigItemContentAssoc",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ConfigForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "configItemId",
            "action" : "",
            "id" : "AddProductConfigItemContentAssoc_configItemId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddProductConfigItemContentAssoc",
            "id" : "AddProductConfigItemContentAssoc_contentId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupContent",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "contentId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "contentId",
            "style" : "",
            "id" : "AddProductConfigItemContentAssoc_contentId",
            "title" : "Content ID",
            "type" : "LOOKUP"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Config Item Content Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductConfigItemContentAssoc",
            "options" : [ {
            "description" : "Description",
            "key" : "DESCRIPTION"
            }, {
            "description" : "Description - Long",
            "key" : "LONG_DESCRIPTION"
            }, {
            "description" : "Image",
            "key" : "IMAGE_URL"
            }, {
            "description" : "Instructions",
            "key" : "INSTRUCTIONS"
            } ],
            "disabled" : "false",
            "id" : "AddProductConfigItemContentAssoc_confItemContentTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "confItemContentTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-17%2011:07:28.003",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductConfigItemContentAssoc",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductConfigItemContentAssoc_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-03-17%2011:07:28.003",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddProductConfigItemContentAssoc",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddProductConfigItemContentAssoc_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductConfigItemContentAssoc",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddProductConfigItemContentAssoc_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Add",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "addContentToProductConfigItem"
    },
    {
        "columns" : [ {
            "name" : "productId",
            "title" : "Product ID"
        }, {
            "name" : "productName",
            "title" : "Name"
        }, {
            "name" : "piecesIncluded",
            "title" : "Pieces Included"
        } ],
        "formName" : "ListProductConfigItem",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ConfigForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "configItemId",
            "action" : "",
            "id" : "ListProductConfigItem_configItemId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "sequenceNum",
            "action" : "",
            "id" : "ListProductConfigItem_sequenceNum",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "defaultConfigOptionId",
            "action" : "",
            "id" : "ListProductConfigItem_defaultConfigOptionId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "thruDate",
            "action" : "",
            "id" : "ListProductConfigItem_thruDate",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "fromDate",
            "action" : "",
            "id" : "ListProductConfigItem_fromDate",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "configTypeId",
            "action" : "",
            "id" : "ListProductConfigItem_configTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "isMandatory",
            "action" : "",
            "id" : "ListProductConfigItem_isMandatory",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "originGeoId",
            "action" : "",
            "id" : "ListProductConfigItem_originGeoId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "detailScreen",
            "action" : "",
            "id" : "ListProductConfigItem_detailScreen",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "requireInventory",
            "action" : "",
            "id" : "ListProductConfigItem_requireInventory",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "quantityUomId",
            "action" : "",
            "id" : "ListProductConfigItem_quantityUomId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "mediumImageUrl",
            "action" : "",
            "id" : "ListProductConfigItem_mediumImageUrl",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "introductionDate",
            "action" : "",
            "id" : "ListProductConfigItem_introductionDate",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "shippingHeight",
            "action" : "",
            "id" : "ListProductConfigItem_shippingHeight",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "originalImageUrl",
            "action" : "",
            "id" : "ListProductConfigItem_originalImageUrl",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "inShippingBox",
            "action" : "",
            "id" : "ListProductConfigItem_inShippingBox",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "detailImageUrl",
            "action" : "",
            "id" : "ListProductConfigItem_detailImageUrl",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "supportDiscontinuationDate",
            "action" : "",
            "id" : "ListProductConfigItem_supportDiscontinuationDate",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "productWidth",
            "action" : "",
            "id" : "ListProductConfigItem_productWidth",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "includeInPromotions",
            "action" : "",
            "id" : "ListProductConfigItem_includeInPromotions",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "configId",
            "action" : "",
            "id" : "ListProductConfigItem_configId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "billOfMaterialLevel",
            "action" : "",
            "id" : "ListProductConfigItem_billOfMaterialLevel",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "lotIdFilledIn",
            "action" : "",
            "id" : "ListProductConfigItem_lotIdFilledIn",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "productRating",
            "action" : "",
            "id" : "ListProductConfigItem_productRating",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "createdByUserLogin",
            "action" : "",
            "id" : "ListProductConfigItem_createdByUserLogin",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "brandName",
            "action" : "",
            "id" : "ListProductConfigItem_brandName",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "requireAmount",
            "action" : "",
            "id" : "ListProductConfigItem_requireAmount",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "smallImageUrl",
            "action" : "",
            "id" : "ListProductConfigItem_smallImageUrl",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "taxable",
            "action" : "",
            "id" : "ListProductConfigItem_taxable",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "primaryProductCategoryId",
            "action" : "",
            "id" : "ListProductConfigItem_primaryProductCategoryId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "salesDiscontinuationDate",
            "action" : "",
            "id" : "ListProductConfigItem_salesDiscontinuationDate",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "salesDiscWhenNotAvail",
            "action" : "",
            "id" : "ListProductConfigItem_salesDiscWhenNotAvail",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "returnable",
            "action" : "",
            "id" : "ListProductConfigItem_returnable",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "weightUomId",
            "action" : "",
            "id" : "ListProductConfigItem_weightUomId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "isVirtual",
            "action" : "",
            "id" : "ListProductConfigItem_isVirtual",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "priceDetailText",
            "action" : "",
            "id" : "ListProductConfigItem_priceDetailText",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "reserv2ndPPPerc",
            "action" : "",
            "id" : "ListProductConfigItem_reserv2ndPPPerc",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "widthUomId",
            "action" : "",
            "id" : "ListProductConfigItem_widthUomId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "longDescription",
            "action" : "",
            "id" : "ListProductConfigItem_longDescription",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "diameterUomId",
            "action" : "",
            "id" : "ListProductConfigItem_diameterUomId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "autoCreateKeywords",
            "action" : "",
            "id" : "ListProductConfigItem_autoCreateKeywords",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "amountUomTypeId",
            "action" : "",
            "id" : "ListProductConfigItem_amountUomTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "productDiameter",
            "action" : "",
            "id" : "ListProductConfigItem_productDiameter",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "ratingTypeEnum",
            "action" : "",
            "id" : "ListProductConfigItem_ratingTypeEnum",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "description",
            "action" : "",
            "id" : "ListProductConfigItem_description",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "chargeShipping",
            "action" : "",
            "id" : "ListProductConfigItem_chargeShipping",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "reservNthPPPerc",
            "action" : "",
            "id" : "ListProductConfigItem_reservNthPPPerc",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "quantityIncluded",
            "action" : "",
            "id" : "ListProductConfigItem_quantityIncluded",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "heightUomId",
            "action" : "",
            "id" : "ListProductConfigItem_heightUomId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "internalName",
            "action" : "",
            "id" : "ListProductConfigItem_internalName",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "lastModifiedByUserLogin",
            "action" : "",
            "id" : "ListProductConfigItem_lastModifiedByUserLogin",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "virtualVariantMethodEnum",
            "action" : "",
            "id" : "ListProductConfigItem_virtualVariantMethodEnum",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "shippingWeight",
            "action" : "",
            "id" : "ListProductConfigItem_shippingWeight",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "shippingWidth",
            "action" : "",
            "id" : "ListProductConfigItem_shippingWidth",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "shippingDepth",
            "action" : "",
            "id" : "ListProductConfigItem_shippingDepth",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "reservMaxPersons",
            "action" : "",
            "id" : "ListProductConfigItem_reservMaxPersons",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "fixedAmount",
            "action" : "",
            "id" : "ListProductConfigItem_fixedAmount",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "inventoryItemTypeId",
            "action" : "",
            "id" : "ListProductConfigItem_inventoryItemTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "productDepth",
            "action" : "",
            "id" : "ListProductConfigItem_productDepth",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "facilityId",
            "action" : "",
            "id" : "ListProductConfigItem_facilityId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "comments",
            "action" : "",
            "id" : "ListProductConfigItem_comments",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "releaseDate",
            "action" : "",
            "id" : "ListProductConfigItem_releaseDate",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "productHeight",
            "action" : "",
            "id" : "ListProductConfigItem_productHeight",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "lastModifiedDate",
            "action" : "",
            "id" : "ListProductConfigItem_lastModifiedDate",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "defaultShipmentBoxTypeId",
            "action" : "",
            "id" : "ListProductConfigItem_defaultShipmentBoxTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "orderDecimalQuantity",
            "action" : "",
            "id" : "ListProductConfigItem_orderDecimalQuantity",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "inventoryMessage",
            "action" : "",
            "id" : "ListProductConfigItem_inventoryMessage",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "productWeight",
            "action" : "",
            "id" : "ListProductConfigItem_productWeight",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "depthUomId",
            "action" : "",
            "id" : "ListProductConfigItem_depthUomId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "productTypeId",
            "action" : "",
            "id" : "ListProductConfigItem_productTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "createdDate",
            "action" : "",
            "id" : "ListProductConfigItem_createdDate",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "isVariant",
            "action" : "",
            "id" : "ListProductConfigItem_isVariant",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "largeImageUrl",
            "action" : "",
            "id" : "ListProductConfigItem_largeImageUrl",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "requirementMethodEnumId",
            "action" : "",
            "id" : "ListProductConfigItem_requirementMethodEnumId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Product ID",
            "type" : "HYPERLINK",
            "target" : "EditProductConfigs",
            "name" : "productId",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ListProductConfigItem_productId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formName":"EditProductConfigs",
                "formLocation":"component://kwikstore/widget/ConfigForms.xml"
            },
            "event":"edit"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productName",
            "description" : "",
            "style" : "",
            "id" : "ListProductConfigItem_productName",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "piecesIncluded",
            "description" : "",
            "style" : "",
            "id" : "ListProductConfigItem_piecesIncluded",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    }
]